module.exports = __webpack_public_path__ + "static/media/contact-small.b7a8a608.webp";